export const RegistrationReferrer = {

  registerPath: 'registrierung',

  init: function () {
    RegistrationReferrer.setExternalReferrer();
    RegistrationReferrer.setInternalReferrer();
    RegistrationReferrer.setLandingpageCookie();
  },

  setExternalReferrer: function () {
    var cname = 'referrer';
    var cookieValue = document.referrer;
    var $registrationField = $('#registration-referrer');

    if (typeof Cookies.get(cname) === 'undefined') {
      Cookies.set(cname, cookieValue);
    }

    if ($registrationField.length > 0) {
      $registrationField.val(Cookies.get(cname));
    }
  },

  setInternalReferrer: function () {
    var cname = 'internal_referrer';
    var cookieValue = window.location.href;
    var $registrationField = $('#registration-internal_referrer');
    var pathname = window.location.pathname;
    var patharray = pathname.split('/');

    if (
      patharray.length > 2
      && patharray[1] !== RegistrationReferrer.registerPath
    ) {
      Cookies.set(cname, cookieValue);
    }

    if ($registrationField.length > 0) {
      $registrationField.val(Cookies.get(cname));
    }
  },

  setLandingpageCookie: function () {
    var cname = 'landingpage';
    var cookieValue = window.location.href;
    var $registrationField = $('#registration-landingpage');

    if (typeof Cookies.get(cname) === 'undefined') {
      cookieValue = cookieValue.replace(window.location.origin + '/', '');
      Cookies.set(cname, cookieValue);
    }

    if ($registrationField.length > 0) {
      $registrationField.val(Cookies.get(cname));
    }
  }
};
